<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
      </template>
      <a-form-model :colon="false" :label-col="{span:8}" :model="order" :wrapper-col="{span:16}">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderNo')">
              <vxe-input v-model="order.no" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.owner')">
              <vxe-input v-model="order.owner.name" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supplier')">
              <vxe-input v-model="order.customer.name" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.invoiceDate')">
              <vxe-input v-model="order.invoiceTime" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderType')">
              <vxe-input v-model="order.orderType.name" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderStatus')">
              <vxe-select v-model="order.orderStatus" :options="orderStatus" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.dataSource')">
              <vxe-select v-model="order.dataSource" :options="dataSources" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.maker')">
              <vxe-input v-model="order.operator" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <vxe-card>
      <vxe-table ref="table" :data="details" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="200"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="200"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
        <vxe-column field="asnDetail.lotNo" title="business.label.lot" width="150"/>
        <vxe-column field="asnDetail.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="asnDetail.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="asnDetail.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="purchaseOrder.no" title="business.label.purchaseOrderNo" width="150"/>
        <vxe-column field="asnDetail.quantity" title="business.label.plannedQuantity" width="150"/>
        <vxe-column field="asnDetail.receivedQuantity" title="business.label.receivedQuantity" width="150"/>
        <vxe-column field="asnDetail.acceptedQuantity" title="business.label.acceptedQuantity" width="150"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll, findOne } from '@/api/Api'
import { AsnOrder } from '@/api/dto/order/AsnOrder'

export default {
  name: 'ReceivingCloseDetail',
  props: {
    orderStatus: { type: Array, default: [] },
    dataSources: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      order: new AsnOrder(),
      details: [],
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getDetails()
    },
    getDetail(id) {
      this.loading = true
      findOne('asnOrderFactory', { id: id }).then(res => {
        if (res.success) {
          this.build(res.result)
        }
      }).finally(() => this.loading = false)
    },
    build(order) {
      this.order = new AsnOrder(order)
      this.getDetails()
    },
    getDetails() {
      if (this.order.isNew()) return
      this.loading = true
      findAll('asnDetailFactory', { 'order.id': this.order.id }, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.details = res.result
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>